import React, { useState, useRef, useEffect } from 'react';
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import { BiHelpCircle } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { showFeedbackModal } from 'store/core/actions';
import styles from './footer.module.css';
import { selectUsername } from 'store/core/selectors';
import html2canvas from 'html2canvas';

export const Footer = ({
  rootRef,
  isCollapsed = false,
  dataDate = undefined,
}) => {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const openFeedbackModal = () => {
    setIsMenuOpen(false);
    html2canvas(rootRef.current).then((canvas) => {
      const imageUrl = canvas.toDataURL();
      dispatch(showFeedbackModal(imageUrl));
    });
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div
      className={`${styles.root} ${!isCollapsed && 'flex_align_items_start'}`}
    >
      <div className={styles.helpContainer} ref={menuRef}>
        <div onClick={toggleMenu} className={styles.feedBackButton}>
          <div className={styles.star_icon}>
            <BiHelpCircle />
          </div>
          <p className={styles.feedback_text}>Help</p>
        </div>

        {isMenuOpen && (
          <div className={styles.helpMenu}>
            <div onClick={openFeedbackModal} className={styles.menuItem}>
              <AiOutlineQuestionCircle className={styles.menuIcon} />
              <span>Give Feedback</span>
            </div>
          </div>
        )}
      </div>
      <CurrentUser isCollapsed={isCollapsed} />
      {dataDate && <div className={styles.dataDate}>Data as of {dataDate}</div>}
    </div>
  );
};

const CurrentUser = ({ isCollapsed = false }) => {
  const { username, initials } = useSelector(selectUsername);

  return (
    <div className={styles.root_button}>
      <div className={styles.user}>
        <div
          className={
            !isCollapsed ? styles.user_names_active : styles.user_names
          }
        >
          <div className={styles.badge}>{initials.toUpperCase()}</div>
          {!isCollapsed && <div className={styles.name_wrap}>{username}</div>}
        </div>
      </div>
    </div>
  );
};

export default Footer;
